import { createDetailReducer } from '../../../common/services/reducerCreator';

export default createDetailReducer({
  modelName: 'TEAMSEASON',
  inside: {
    team: { get: 'teamSeasons' },
  },
});
